import { render, staticRenderFns } from "./CheckoutTemplate.vue?vue&type=template&id=6ba6f189&scoped=true"
import script from "./CheckoutTemplate.vue?vue&type=script&lang=js"
export * from "./CheckoutTemplate.vue?vue&type=script&lang=js"
import style0 from "./CheckoutTemplate.vue?vue&type=style&index=0&id=6ba6f189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6f189",
  null
  
)

export default component.exports